export default {
  no_storefront_found: {
    title: 'No se encontró tienda',
    description: 'Por favor, cree una tienda.',
  },
};
